import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Assets/logo.png";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Vision", to: "/vision" },
  { label: "Services", to: "/services" },
  { label: "Our Team", to: "/activity" },
  { label: "Contact", to: "/contact" },
];

const Site2Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  return (
    <nav
      style={{
        backgroundColor: scrolled ? "rgba(255, 255, 255, 0.98)" : "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(14px)",
        borderBottom: "1px solid rgba(72, 31, 87, 0.12)",
        transition: "all 0.35s ease",
      }}
      className="fixed top-0 left-0 right-0 z-50 px-6 lg:px-14 py-3"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img
            src={logo}
            alt="Tarak Global Enterprises"
            style={{ height: "40px", width: "auto", objectFit: "contain", flexShrink: 0 }}
          />
          <span className="hidden sm:block text-[#481F57] text-sm font-bold tracking-wide">
            Tarak Global Enterprises
          </span>
        </Link>

        {/* Desktop */}
        <ul className="hidden md:flex items-center gap-6">
          {NAV_LINKS.map((l) => {
            const active = location.pathname === l.to || (l.to === "/" && location.pathname === "/site2") || (l.to !== "/" && location.pathname === `/site2${l.to}`);
            return (
              <li key={l.label}>
                <Link
                  to={l.to}
                  style={{
                    color: active ? "#481F57" : "rgba(31, 41, 55, 0.75)",
                    borderBottom: active ? "2px solid #481F57" : "2px solid transparent",
                    paddingBottom: "2px",
                  }}
                  className="text-sm font-semibold transition-colors duration-200 hover:text-[#481F57]"
                >
                  {l.label}
                </Link>
              </li>
            );
          })}
          <li>
            <Link
              to="/contact"
              style={{ background: "linear-gradient(135deg,#481F57,#6B3080)" }}
              className="text-white text-sm font-bold px-5 py-2 rounded-full hover:opacity-90 transition-opacity shadow-md"
            >
              Get in Touch
            </Link>
          </li>
        </ul>


        {/* Mobile toggle */}
        <button
          className="md:hidden text-[#481F57] text-2xl focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div
          style={{ backgroundColor: "rgba(255, 255, 255, 0.98)" }}
          className="md:hidden absolute left-0 right-0 top-full px-6 py-4 flex flex-col gap-4 border-t border-purple-900/10 shadow-lg"
        >
          {NAV_LINKS.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              className="text-gray-700 hover:text-[#481F57] font-semibold text-base py-1"
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Site2Navbar;
